








































































































































































































import { Vue, Component } from 'vue-property-decorator'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import MenuItemForm from './MenuItemForm.vue'

@Component({
    components: {
        ConfirmDialog,
        MenuItemForm
    }
})
export default class MenuItemList extends Vue {
    loading = false
    option: string|null = null
    editChild = false
    selectedParent: object = {}
    actionEnabled = false
    columns = [
        {
            text: 'ID',
            value: 'menuItemId'
        },
        {
            text: 'Title',
            value: 'menuItemTitle'
        },
        {
            text: 'Icon',
            value: 'menuItemIcon'
        },
        {
            text: 'Route',
            value: 'menuItemUrl'
        },
        {
            text: 'Parent',
            value: 'menuItemParentId.menuItemParentId'
        },
        {
            text: 'Priority',
            value: 'menuItemPriority'
        },
        {
            text: 'Active',
            value: 'menuItemEnabled'
        },
        {
            text: 'Last Modified',
            value: 'dateModified',
            customField: {
                type: 'date'
            }
        },
        {
            text: 'Options',
            value: 'options'
        }
    ]

    confirmDialogTrigger = false
    confirmDialogData = null

    items: {[key: string]: string}[] = []

    cardTitle = ''
    showCard = false

    async mounted () {
        if (this.$route.params.action) {
            this.showCard = true
            this.actionEnabled = true
            if (this.$route.params.action) this.option = 'item'
        }

        await this.getData()

        if (this.$route.params.parentItem) {
            const found = this.items.find(i => i.menuItemId === this.$route.params.parentItem)
            if (found) this.editChildren(found)
        }
    }

    getData () {
        return new Promise(resolve => {
            this.loading = true
            this.$store.dispatch('getMenuById', this.$route.params.parent)
                .then(resp => {
                    this.loading = false
                    if (resp?.status === 200) {
                        this.items = this.$store?.state?.MenuStore?.menuForm?.menuItems || []
                        resolve()
                    }
                })
        })
    }

    editChildren (item: {[key: string]: string}) {
        this.editChild = true
        this.selectedParent = item
    }

    confirmedDialog (object: {[key: string]: string}) {
        this.$store.dispatch('deleteMenuItem', object.menuItemId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.getData()
                }
            })
    }

    changeMode (mode: string, id: string, parentItem?: string) {
        this.actionEnabled = true
        const params: {[key: string]: string} = {
            parent: this.$route.params.parent,
            action: mode
        }

        if (parentItem) params.parentItem = parentItem
        if (id) params.id = id

        this.$router.push({
            name: 'MenuItemForm',
            params
        })
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
